import { Tabs, Typography } from 'antd';
import UserRequestsTab from './UserRequestsTab';
import CompanyBrandRequestsTab from './CompanyBrandRequestsTab';
import { useState } from 'react';

export default function AdminBrandNames() {
  const [activeKey, setActiveKey] = useState('user-requests');

  const requestsTabItems = [
    {
      key: 'user-requests',
      label: (
        <span
          style={{
            fontSize: 18,
            color: activeKey === 'user-requests' ? undefined : '#9FA1AD',
            fontWeight: 500,
          }}
        >
          User Requests
        </span>
      ),
      children: <UserRequestsTab />,
    },
    {
      key: 'company-brand-requests',
      label: (
        <span
          style={{
            fontSize: 18,
            color: activeKey === 'company-brand-requests' ? undefined : '#9FA1AD',
            fontWeight: 500,
          }}
        >
          Company Brand Requests
        </span>
      ),
      children: <CompanyBrandRequestsTab />,
    },
  ];

  return (
    <>
      <Typography.Title level={2} style={{ fontSize: 28 }}>Requests</Typography.Title>
      <Tabs
        items={requestsTabItems}
        activeKey={activeKey}
        onChange={setActiveKey}
      />
    </>
  );
}
